import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import account from './routes/account';
import single from './routes/single';
import singleEvents from './routes/ss';
import pageTemplateSingleSummits from './routes/ss';
import pageTemplateDefault from './routes/ss';
import singleThemePages from './routes/ss';
import singleSummits from './routes/ss';
import singleWebinars from './routes/single-webinar';
import singleSummitVideos from './routes/single-webinar';
import archive from './routes/archive';
import login from './routes/login';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  common,
  home,
  account,
  single,
  pageTemplateDefault,
  singleEvents,
  pageTemplateSingleSummits,
  singleSummits,
  singleThemePages,
  singleWebinars,
  singleSummitVideos,
  archive,
  login
});

/** Load Events */
routes.loadEvents();
